module.exports = __webpack_public_path__ + "static/media/loader-fild.c48a45bf.svg";